import { Controller } from "@hotwired/stimulus"

export default class AircraftPositionController extends Controller {
    static targets = ['altitude', 'latitude', 'longitude', 'aircraft', 'message']

    async updateWithCurrent() {
        const aircraft = this.aircraftTarget.value.toUpperCase()
        const button = event.target
        if (/^CAP\d+$/.test(aircraft)) {
            button.classList.add('is-loading')
            const response = await fetch("/highbird_checks/position?aircraft=" + aircraft)
            if (response.ok) {
                const data = await response.json() // Parse response as JSON

                this.altitudeTarget.value = data.altitude
                this.latitudeTarget.value = data.latitude
                this.longitudeTarget.value = data.longitude
                this.messageTarget.textContent = ""
                button.classList.remove('is-loading')
            } else {
                this.messageTarget.textContent = 'Unable to retrieve aircraft position'
                button.classList.remove('is-loading')
            }
        } else {
            this.messageTarget.textContent = "Ensure aircraft call is in format CAP1234"
            button.classList.remove('is-loading')
        }

    }

    openFlightAware() {
        const aircraft = this.aircraftTarget.value.toUpperCase()
        if (/^CAP\d+$/.test(aircraft)) {
            window.open('https://www.flightaware.com/live/flight/' + aircraft)
            this.messageTarget.textContent = ""
        } else {
            this.messageTarget.textContent = "Ensure aircraft call is in format CAP1234"
        }
    }
}